import React, { useEffect, useState, useRef } from 'react';
import swal from 'sweetalert2';
import * as helper from '../components/global/helper';
import noData from '../assets/images/no-data.png';
import ReactTooltip from "react-tooltip";
import moment from 'moment';
import Select from 'react-select';

const imgUrl = 'https://metromatrix.s3.ap-south-1.amazonaws.com/Public/MetroMatrix/Content/';

import { addComment, deleteComment, getClientDetails, getClientList, getMedicalForm, getMedicalFormJuvenile, postClient, postClientList, postMedicalForm, postMedicalFormJuvenile, sendLink, verifyMedicalForm } from './api/dashboardAPI';
import { assignDoctor, getSlots, scheduleClient } from './api/doctorAPI';
import { getAuthState } from '../assets/scripts/login-util';
import { downloadAndOpenPDFHandler, downloadVideoHandler } from './global/helper';
import { uploadPrivateFile } from './api/fileAPI';

const Dashboard = (props) => {

    const colors = ['#007bff', '#adb5bd', '#17a2b8', '#02b875'];

    const allowedDivisions = ['DO-ALIGARH','ASANSOL DO','AURANGABAD DO','BANGLORE DO-II','BARDHAMAN DO','BELGAUM DO','KMDO II','CHENNAI DO-I','CHENNAI DO-II','COIMBATORE DO','DEHRADUN DO','DHARWAD DO','ERNAKULAM DO','DO-FAIZABAD','DO-GORAKHPUR','DO-HALDWANI','INDORE DO','JABALPUR DO','JALPIGURI DO','JORHAT DO','KARIMNAGAR DO','KHARAGHPUR DO','KOLHAPUR DO','KOTTAYAM DO','KOZHI-KODI DO','MADURAI DO','MUMBAI DO-I','MYSORE DO','NASHIK DO','PUNE DO-II','RAICHUR DO','RAJKOT DO','SALEM DO','SATARA DO','SHIMOGA DO','SILCHAR DO','SURAT DO','TECH-TERM','THANE DO','THANJAVUR DO','THRISSUR DO','TIRUNELVELI DO','TRIVANADRUM DO','UDUPI DO','VADODARA DO','VELLORE DO','VISAKHAPATNAM DO','WARANGAL DO','DO-BAREILLY','AHMEDABAD DO','BANGLORE DO-I','KSDO','MUMBAI DO-III', 'VARANASI DO', 'LUCKNOW DO', 'KANPUR DO', 'PRYAGRAJ DO', 'ALLAHABAD DO', 'AYODHYA DO', 'RAIPUR DO', 'BILASPUR DO', 'SATNA DO', 'SHAHDOL DO', 'GWALIOR DO', 'BHOPAL DO', 'HYDERABAD DO', 'MACHILIPATNAM DO', 'SECUNDERABAD_DO'];

    const [clients,             setClients]             = useState([]);
    const [clientList,          setClientList]          = useState([]);
    const [clientList1,         setClientList1]         = useState([]);
    const [comments,            setComments]            = useState([]);
    const [doctors,             setDoctors]             = useState([]);
    const [slots,               setSlots]               = useState([]);
    const [selectedSlot,        setSelectedSlot]        = useState(null);
    const [video,               setVideo]               = useState(null);
    const [videoURL,            setVideoURL]            = useState(null);
    const videoRef                                      = useRef(null);

    const [client,              setClient]              = useState({ID: 0});
    const [doctor,              setDoctor]              = useState(null);
    const [tpa,                 setTPA]                 = useState(null);
    const [schedule,            setSchedule]            = useState(null);
    const [validated,           setValidated]           = useState(false);
    const [linkValidated,       setLinkValidated]       = useState(false);
    const [formValidated,       setFormValidated]       = useState(false);
    const [countryCode,         setCountryCode]         = useState({ value: "+91", label: "India (+91)" });
    const [mobile,              setMobile]              = useState(null);
    const [medicalForm,         setMedicalForm]         = useState([]);
    const [screenShots,         setScreenShots]         = useState([]);

    const [search,              setSearch]              = useState('');
    const [debouncedSearch,     setDebouncedSearch]     = useState('');
    const searchDebounceTimeout                         = useRef(null);

    const [auth,                setAuth]                = useState(getAuthState('user'));
    

    useEffect(() => {
        const addModalElement = document.getElementById('addModal');
        const uploadModalElement = document.getElementById('uploadModal');
        const videoModalElement = document.getElementById('videoModal'); 
        const handleAddModalHide = () => resetData();
        const handleUploadModalHide = () => resetUploadData();
        const handleVideoModalHide = () => {
            if (videoRef.current) {
              videoRef.current.pause();
            }
        };
        addModalElement.addEventListener('hidden.bs.modal', handleAddModalHide);
        uploadModalElement.addEventListener('hidden.bs.modal', handleUploadModalHide);
        videoModalElement.addEventListener('hidden.bs.modal', handleVideoModalHide);

        return () => {
            addModalElement.removeEventListener('hidden.bs.modal', handleAddModalHide);
            uploadModalElement.removeEventListener('hidden.bs.modal', handleUploadModalHide);
            videoModalElement.removeEventListener('hidden.bs.modal', handleVideoModalHide);
        };    
        
    }, [])

    useEffect(() => {
        if (searchDebounceTimeout.current) {
            clearTimeout(searchDebounceTimeout.current);
        }

        searchDebounceTimeout.current = setTimeout(() => {
            setDebouncedSearch(search);
        }, 500);

        return () => {
            if (searchDebounceTimeout.current) {
                clearTimeout(searchDebounceTimeout.current);
            }
        };
    }, [search]);

    useEffect(() => {
        fetchClients({
            search: debouncedSearch,
            type: props.type,
            tpa: props.tpa,
            status: props.status
        });
    }, [debouncedSearch, props.type, props.tpa, props.status]);


    useEffect(() => {
        if (video) {
            const url = URL.createObjectURL(video);
            setVideoURL(url);
        }else{
            URL.revokeObjectURL(videoURL);
            setVideoURL(null);
        }
    }, [video])

    const handleDownloadPDF = (e, clientId) => {
        e.stopPropagation();
        downloadAndOpenPDFHandler(clientId);

        const modalElement = document.getElementById('viewModal');
        const closeButton = modalElement.querySelector('.btn-close');

        const closeModalAfterOpen = () => {
            closeButton.click();
            modalElement.removeEventListener('shown.bs.modal', closeModalAfterOpen);
        };

        modalElement.addEventListener('shown.bs.modal', closeModalAfterOpen);
    };

    const handleDownloadVideo = async (clientId) => {
        if (!video) {
            const videoBlob = await downloadVideoHandler(clientId);
            setVideo(videoBlob);
        }
    };

    const viewForm = async (clientId) => {  
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });
            
            const { Answers, ScreenShots } = await (client.TestType === 'JMER' ? getMedicalFormJuvenile(clientId) : getMedicalForm(clientId));
            setMedicalForm(Answers);
            setScreenShots(ScreenShots.map((s) => {
                return {...s, Action: 'Y' }
            }));
            swal.close();
        } catch (err) {
            swal.close();
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    };

    const fetchClients = async (filters = {}) => {
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });
            const { Clients } = await getClientList(filters);
            setClients(Clients);
            swal.close();
            return Clients;
        } catch (err) {
            swal.close();
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }

    const refreshClients = async () => {
        await fetchClients({
            search,
            type: props.type,
            tpa: props.tpa,
            status: props.status
        });
    }

    const fetchClientDetails = async (m) => {
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });
            const { Client, Comments, Doctors, Doctor, Schedule, TPA } = await getClientDetails(m.ID);

            const originalDivision = Client.Division || '';
            if (originalDivision && !allowedDivisions.includes(originalDivision)) {
                Client['M-Division'] = originalDivision;
                Client.Division = 'OTHERS';
            }

            setClient(Client);
            setComments(Comments);
            setDoctors(Doctors)
            setDoctor(Doctor);
            setSchedule(Schedule);
            setTPA(TPA);
            swal.close();
        } catch (err) {
            swal.close();
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }

    const postClientData = async(e)=> {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {     
            e.stopPropagation();
            setValidated(true);
        }else{
            try {              
                if (client.ID < 0) {
                    document.querySelector('#addModal .btn-close').click();
                    document.querySelector('#btnUpload').click();
                }else{
                    swal.fire({
                        titleText           : 'Loading',
                        text                : 'Please Wait...',
                        showConfirmButton   : false,
                        allowOutsideClick   : false,
                        didOpen: () => {
                            swal.showLoading();
                        }
                    });
    
                    await postClient({
                        ID          : client.ID ?? 0,
                        TPAID       : client.TPAID || props.tpaList[0].ID,
                        ProposalNo  : client.ProposalNo,
                        Type        : client.Type || 'NB',
                        Name        : client.Name,
                        Age         : client.Age || null,
                        Email       : client.Email || '',
                        Contact1    : client.Contact1,
                        Contact2    : client.Contact2 || '',
                        TestType    : client.TestType || 'VMER',
                        Language    : client.Language || '',
                        City        : client.City || '',
                        State       : client.State || '',
                        Division    : client.Division == 'OTHERS' ? client['M-Division'] : client.Division,
                        BranchCode  : client.BranchCode,
                        SumAssured  : client.SumAssured || '',
                        Remark      : client.Remark || ''
    
                    });
                    await refreshClients();
                    document.querySelector('#addModal .btn-close').click();

                    swal.close();

                    if (client.ID) {
                        swal.fire({
                            icon: 'success',
                            title: '<small>Client updated successfully!</small>',
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    } else {
                        swal.fire({
                            icon: 'success',
                            title: '<small>Client added successfully!</small>',
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    }
                }
            } catch (err) {
                swal.close();
                swal.fire({
                    icon              : "error",
                    titleText         : "Error!",
                    text              : err.message
                  })
                return;  
            }       
        }    
    }

    const postClientListData = async()=> {
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });

            await postClientList(clientList);
            await refreshClients();
            document.querySelector('#uploadModal .btn-close').click();

            swal.close();

            if (client.ID) {
                swal.fire({
                    icon: 'success',
                    title: '<small>Client updated successfully!</small>',
                    showConfirmButton: false,
                    timer: 1500,
                });
            } else {
                swal.fire({
                    icon: 'success',
                    title: '<small>Client added successfully!</small>',
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
      
        } catch (err) {
            swal.close();
            swal.fire({
                icon              : "error",
                titleText         : "Error!",
                text              : err.message
              })
            return;  
        }  
    }

    const sendComment = async () => {
        try {

            const comment = document.getElementById('txtComment').value;
            if (comment != '') {
                await addComment({ClientID: client.ID, Comment: comment});
                document.getElementById('txtComment').value = '';
                fetchClientDetails(client);  
            }  
        } catch (err) {
            swal.fire({
                icon              : "error",
                titleText         : "Error!",
                text              : err.message
              })
            return;  
        }  
    };

    const removeComment = async (id) => {
        try {
            await deleteComment(id);
            fetchClientDetails(client);  
        } catch (err) {
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }

    const assignDoctorData = async () => {
        try {
        
            const doctorId = document.getElementById('ddlDoctor').value;

            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });

            await assignDoctor({
                ClientID    : client.ID,
                DoctorID    : parseInt(doctorId)
            });

            document.querySelector('#scheduleModal .btn-close').click();
            swal.close();
            fetchClientDetails(client);
            await refreshClients();

        } catch (err) {
            swal.close();
            swal.fire({
                icon              : "error",
                titleText         : "Error!",
                text              : err.message
            })
            return;  
        }  

    };

    const scheduleClientData = async () => {
        try {
        
            const doctorId = document.getElementById('ddlDoctor').value;
            const date = document.getElementById('txtDate').value;            

            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });

            await scheduleClient({
                ClientID    : client.ID,
                DoctorID    : parseInt(doctorId),
                Date        : date,
                From        : selectedSlot.From,
                To          : selectedSlot.To
            });

            document.querySelector('#scheduleModal .btn-close').click();
            swal.close();
            fetchClientDetails(client);
            await refreshClients();

        } catch (err) {
            swal.close();
            swal.fire({
                icon              : "error",
                titleText         : "Error!",
                text              : err.message
            })
            return;  
        }  

    };

    const fillSchedule = (c) => {

        if (c.Status == 'Assigned' || c.Status == "Scheduled") {
            document.getElementById('ddlDoctor').value = doctor.ID;

            if (c.Status == "Scheduled" && schedule) {
                document.getElementById('txtDate').value = moment(schedule.Date).format('YYYY-MM-DD');
                getDoctorSlots();
            }            
        }
    };

    const getDoctorSlots = async () => {
        try {
        
            const doctorId = document.getElementById('ddlDoctor').value;
            const date = document.getElementById('txtDate').value;

            if (date) {
                swal.fire({
                    titleText           : 'Loading',
                    text                : 'Please Wait...',
                    showConfirmButton   : false,
                    allowOutsideClick   : false,
                    didOpen: () => {
                        swal.showLoading();
                    }
                });

                const { Slots } = await getSlots(doctorId, date);

                setSlots(Slots);
                setSelectedSlot(null);
                swal.close();
            }

        } catch (err) {
            swal.close();
            swal.fire({
                icon              : "error",
                titleText         : "Error!",
                text              : err.message
              })
            return;  
        }  
    };

    const handleData = (key, value)=>{
        setClient((d)=> { return {...d, [key] : value} });
    };

    const handleFormData = (key, value) => {
        setMedicalForm((prevForm) => {
            // Check if the QuestionID exists in the array
            const index = prevForm.findIndex((item) => item.QuestionID === key);
    
            if (index !== -1) {
                // Update the existing object
                const updatedForm = [...prevForm];
                updatedForm[index].Answer = value;
                return updatedForm;
            } else {
                // Add a new object for the new QuestionID
                return [...prevForm, { QuestionID: key, Answer: value }];
            }
        });
    };

    const handleElaboration = (key, value) => {
        setMedicalForm((prevForm) => {
            // Check if the QuestionID exists in the array
            const index = prevForm.findIndex((item) => item.QuestionID === key);
    
            if (index !== -1) {
                // Update the existing object
                const updatedForm = [...prevForm];
                updatedForm[index].Elaboration = value;
                return updatedForm;
            }
        });
    };

    const resetData = () => {
        setClient({ID: 0});
        setDoctor(null);
        setSchedule(null);
        setTPA(null)
        setComments([]);
        setSlots([]);
        setSelectedSlot(null);
        setValidated(false);
        setLinkValidated(false);
        setFormValidated(false);
        setVideo(null);
        setMobile(null);
        setCountryCode({ value: "+91", label: "India (+91)" })
        setMedicalForm([]);
        setScreenShots([]);
    };

    const resetUploadData = () => {
        setClientList([]);
        setClientList1([]);
    };

    const getColorForUserId = (userId) => {
        const colorIndex = userId % colors.length;
        return colors[colorIndex];
    };


    const fileHandler = async (file) => {
        try {
            swal.fire({
                titleText           : 'Processing Excel',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });

            const result = await readFile(file);
            const data = helper.extractExcel(result);

            const rows = parseCSV(data);
            if (rows.length < 2) {
                return showWarning('No data found');
            }

            const headings = rows[0].split(',');
            if (!validateHeadings(headings)) {
                return showWarning('Unknown file. Please upload the file in given format.');
            }

            const content = rows.slice(1);

            let cList = [];
            let cList1 = [];
            const tpaId = document.getElementById('ddlTpa').value;
            const testType = document.getElementById('ddlTestType').value;

            content.forEach((element) => {
                const value = element.split(',');

                const data = helper.validateExcel(value);

                if (data.message != 'Success') {
                    cList1.push({
                        ...data.client,
                        TPAID: tpaId,
                        TestType: testType,
                        Message: data.message
                    })
                }else{
                    cList.push({...data.client, TPAID: tpaId, TestType: testType})
                }
            });

            const recordMap = new Map();

            clients.filter(f => f.TPAID == tpaId && f.TestType == testType).forEach(client => {
                const key = `${client.Contact1}-${client.ProposalNo}`;
                recordMap.set(key, true);
            });

            cList = cList.filter(client => {
                const key = `${client.Contact1}-${client.ProposalNo}`;         
                if (recordMap.has(key)) {
                    cList1.push({...client, Message: 'Duplicate record'});
                  return false;
                } else {
                  recordMap.set(key, true);
                  return true;
                }
            });

            setClientList(cList);
            setClientList1(cList1);

            swal.close();

        } catch (error) {
            swal.close();
            showError('Error reading file. Please try again.');
        }
    }

    const validateHeadings = (headings) => {
        const requiredHeadings = ['proposalno', 'type', 'clientname', 'age', 'contactno', 'contactno2', 'testdetails', 'city', 'state', 'email', 'language', 'division', 'branchcode', 'sumassured', 'remark'];
        return requiredHeadings.every((heading, index) => 
            headings[index]?.replace(/\s+/g, '').trim().toLowerCase() === heading
        );
    };

    const readFile = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsBinaryString(file);

            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(reader.error);
        });
    };

    const parseCSV = (data) => {
        return data.split('\n').filter((row) => row.split(',').length > 1);
    };

    const showWarning = (message) => {
        return swal.fire({
            icon: 'warning',
            titleText: 'Warning!',
            text: message
        });
    };

    const showError = (message) => {
        return swal.fire({
            icon: 'error',
            titleText: 'Error!',
            text: message
        });
    };

    const resolveDuplicate = (index) => {
        const list = clientList1.filter(f => f.Message == 'Duplicate record');
        const recordToMove = list[index]

        swal.fire({
            title: "<small>Do you want to upload anyway?</small>",
            showCancelButton: true,
            confirmButtonText: "Upload",
          }).then((result) => {
            if (result.isConfirmed) {
              setClientList1(prevList => prevList.filter(client => client.ProposalNo !== recordToMove.ProposalNo));
              setClientList(prevList => [...prevList, recordToMove]);
              swal.fire({
                icon: 'success',
                title: '<small>Saved!</small>',
                showConfirmButton: false,
                timer: 1500,
            });
            } 
        });
    };

    const resolveAllDuplicate = () => {
        const list = clientList1.filter(f => f.Message == 'Duplicate record');
        swal.fire({
            title: "<small>Do you want to upload all anyway?</small>",
            showCancelButton: true,
            confirmButtonText: "Upload",
          }).then((result) => {
            if (result.isConfirmed) {
              setClientList1(prevList => prevList.filter(client => client.Message !== 'Duplicate record'));
              setClientList(prevList => [...prevList, ...list]);
              swal.fire({
                icon: 'success',
                title: '<small>Saved!</small>',
                showConfirmButton: false,
                timer: 1500,
            });
            } 
        });
    };

    const shareLink = () => {
        setMobile(client.Contact1);
        setCountryCode({ value: "+91", label: "India (+91)" })
        for (let i = 0; i < helper.countryCodes.length; i++) {
            const country = helper.countryCodes[i];
            if (client.Contact1.startsWith(country.value)) {
              setCountryCode({ value: country.value, label: country.label });
              setMobile(client.Contact1.slice(country.value.length));
            }
        }      
    };

    const postShareLink = async(e)=> {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {     
            e.stopPropagation();
            setLinkValidated(true);
        }else{
            try {
                swal.fire({
                    titleText           : 'Loading',
                    text                : 'Please Wait...',
                    showConfirmButton   : false,
                    allowOutsideClick   : false,
                    didOpen: () => {
                        swal.showLoading();
                    }
                });

                await sendLink(client.ID, `${countryCode.value}${mobile}`);
                document.querySelector('#sendLinkModal .btn-close').click();
                swal.close();

                swal.fire({
                    icon: 'success',
                    title: '<small>Link sent successfully!</small>',
                    showConfirmButton: false,
                    timer: 1500,
                });


            } catch (err) {
                swal.close();
                swal.fire({
                    icon              : "error",
                    titleText         : "Error!",
                    text              : err.message
                  })
                return;  
            }
        }
    }

    const postForm = async(e, testType = 'VMER')=> {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {     
            e.stopPropagation();
            setFormValidated(true);
        }else{
            try {
                swal.fire({
                    titleText           : 'Loading',
                    text                : 'Please Wait...',
                    showConfirmButton   : false,
                    allowOutsideClick   : false,
                    didOpen: () => {
                        swal.showLoading();
                    }
                });

                const media = []
                for await (const item of screenShots) {
                    if (item.Action == "A") {
                        const res = await uploadPrivateFile(item.Blob, 'Image');
                        item.Name = res.FileName;
                        media.push({
                            ID: 0,
                            Name: res.FileName,
                            Action: "A"
                        })
                    }else{
                        media.push({
                            ID: item.ID,
                            Name: item.Name,
                            Action: item.Action
                        })
                    }
                }

                if (testType === 'JMER') {
                    await postMedicalFormJuvenile(medicalForm, media);
                    document.querySelector('#juvenileFormModal .btn-close').click();
                } else {
                    await postMedicalForm(medicalForm, media);
                    document.querySelector('#formModal .btn-close').click();
                }
                swal.close();

                swal.fire({
                    icon: 'success',
                    title: '<small>Form submitted successfully!</small>',
                    showConfirmButton: false,
                    timer: 1500,
                });


            } catch (err) {
                swal.close();
                swal.fire({
                    icon              : "error",
                    titleText         : "Error!",
                    text              : err.message
                  })
                return;  
            }
        }
    }

    const verifyClient = async ()=> {
        if (client.Status == 'Success') {
            return;
        }
        try {

            swal.fire({ 
                icon: "warning", 
                text: "Are you sure want to verify ?", 
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(async (result) => {
                if (result.isConfirmed) {
                    swal.fire({
                        titleText           : 'Loading',
                        text                : 'Please Wait...',
                        showConfirmButton   : false,
                        allowOutsideClick   : false,
                        didOpen: () => {
                            swal.showLoading();
                        }
                    });

                    await verifyMedicalForm(client.ID);
                    fetchClientDetails(client);
                    fetchClients();

                    swal.close();
                    swal.fire({
                        icon: 'success',
                        title: '<small>Verified successfully!</small>',
                        showConfirmButton: false,
                        timer: 1500,
                    });


                }
            });


        } catch (err) {
            swal.close();
            swal.fire({
                icon              : "error",
                titleText         : "Error!",
                text              : err.message
              })
            return;  
        }
    }

    const removeScreenshot = (index) => {
        setScreenShots((prevScreenshots) => {
            const filteredScreenshots = prevScreenshots.filter(f => f.Action !== 'D');
            const originalIndex = prevScreenshots.findIndex((s, i) => s === filteredScreenshots[index]);
            return prevScreenshots.map((s, i) =>
                i === originalIndex ? { ...s, Action: 'D' } : s
            );
        });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const blob = new Blob([file], { type: file.type });
            setScreenShots((prevScreenshots) => [...prevScreenshots, {
                ID: 0, 
                ClientID: client.ID, 
                Name: '', 
                Type: 'Screenshot', 
                Buffer: {}, 
                Action: 'A', 
                Blob: blob 
            }]);
        }
    };

    return ( 
        <>
            <div className="navbar navbar-expand-lg fixed-top margin-t58" style={{backgroundColor: '#fff', zIndex: '1'}}>
                <div className="container d-block padding-t10" style={{height: '60px'}}>
                    <div className='row mb-4'>
                        <div className='col-lg-3'>
                            <div className='input-group'>
                                <span className='input-group-text fs-16'><i className="bi bi-search"></i></span>
                                <input 
                                    onChange={({ target }) => setSearch(target.value)}
                                    value={ search || '' }
                                    className="form-control fs-16" 
                                    type="search" 
                                    placeholder="Search"
                                />
                            </div>
                        </div>
                        <div className='col-lg-3 d-none d-lg-block'>
                            <div className='input-group'>
                                <span className='input-group-text fs-16'>TPA</span>
                                <select value={props.tpa} onChange={({ target }) => props.setTPA(target.value)} className="form-select fs-16">
                                    <option value={0}>All</option>
                                    {props.tpaList.length > 0 && props.tpaList.map(m => (
                                        <option key={m.ID} value={m.ID}>{m.Name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='col-lg-3 d-none d-lg-block'>
                            <div className='input-group'>
                                <span className='input-group-text fs-16'>Test</span>
                                <select value={props.type} onChange={({ target }) => props.setType(target.value)} className="form-select fs-16">
                                    <option value={'All'}>All</option>
                                    <option value={'VMER'}>VMER</option>
                                    <option value={'JMER'}>JMER</option>
                                    <option value={'TMER'}>TMER</option>
                                </select>
                            </div>
                        </div>
                        <div className='col-lg-3 d-none d-lg-block'>
                            <div className='input-group'>
                                <span className='input-group-text fs-16'>Status</span>
                                <select value={props.status} onChange={({ target }) =>props.setStatus(target.value)} className="form-select fs-16">
                                    <option value={'All'}>All</option>
                                    <option value={'Pending'}>Pending</option>
                                    <option value={'Assigned'}>Assigned</option>
                                    <option value={'Scheduled'}>Scheduled</option>
                                    <option value={'QC Pending'}>QC Pending</option>
                                    <option value={'Success'}>Success</option>
                                </select>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

            <div className='container margin-t150'>               
                <div className='row'>
                    {clients.length > 0 ? clients.map((m, i) => (
                        <div className='col-md-6' key={i}>
                            <div className={`card mb-4 mx-1`} data-bs-toggle="modal" data-bs-target="#viewModal" key={m.ID} onClick={() => fetchClientDetails(m)}>
                                
                                <div className="card-body">
                                    <h6 className="card-title">{m.Name}</h6>
                                    <span className='card-text fs-16'>
                                        <span>{m.Age ? `Age: ${m.Age} | ` : ''}Contact: {m.Contact1}{m.Contact2 ? `, ${m.Contact2}` : ''}</span><br></br>
                                        <span>{m.City ? `City: ${m.City}` : ''}{m.State ? `${m.City ? ' | ' : ''}State: ${m.State}` : ''}</span><br></br>
                                        <span>{m.Language ? `Language: ${m.Language}` : ''}{m.SumAssured ? `${m.Language ? ' | ' : ''}Sum Assured: ${m.SumAssured}` : ''}</span><br></br>
                                        <span>Type: {m.Type}</span><br></br>
                                        <span>{m.Remark ? `Remark: ${m.Remark}` : ''}</span><br></br>
                                        <span><small><strong>Received Date: {moment(m.CreatedDate).format('DD MMM hh:mm A')}</strong></small></span>
                                    </span><br></br>
                                    <span className={`badge rounded-pill bg-${m.Status == 'Success' ? 'success' : m.Status == 'QC Pending' ? 'info' : m.Status == 'Scheduled' ? 'blue' : m.Status == 'Assigned' ? 'secondary' : 'warning'} mt-3 me-2`}>{m.Status}</span> 
                                    {(m.Status == 'Success' || m.Status == 'QC Pending') && <button type="button" className="btn btn-outline-primary btn-sm" onClick={(e) => handleDownloadPDF(e, m.ID)}><i className="bi bi-filetype-pdf me-1"></i>View PDF</button>}                              
                                </div>
                                <div className="card-footer footer-white fs-16">
                                    <span>Division: {m.Division} | Branch Code: {m.BranchCode}</span>
                                </div>
                                <div className="card-footer fs-16">
                                    <span><span className={`badge bg-${m.TestType == 'VMER' ? 'primary' : 'info'} me-2`}>{m.TestType}</span> Proposal No: {m.ProposalNo}</span>
                                </div>
                            </div>
                        </div>
                    )) : (
                        <div className='col-12'>
                            <div className='text-center mt-5'>
                                <img src={noData} alt="image"  height="150"/>
                                <h5 className='mt-3'>No Clients!</h5>
                            </div>
                        </div>
                    )}   
                </div>
            </div>

            <div id='viewModal' className="modal modal-lg fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">Details</h6>
                            <div className="d-flex align-items-center ms-auto">
                                {((client.TestType == 'VMER' || client.TestType == 'JMER') && client.Status == 'Scheduled') && (
                                    <button type="button" onClick={shareLink} data-bs-toggle="modal" data-bs-target="#sendLinkModal" className="btn btn-outline-success btn-sm me-2">
                                        <i className="bi bi-whatsapp me-2"></i>Share Link
                                    </button>
                                )}   
                                <button type="button" data-bs-toggle="modal" data-bs-target="#addModal" className="btn btn-outline-primary btn-sm me-2">
                                    <i className="bi bi-pencil"></i>
                                </button>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={resetData} aria-label="Close">
                                    <span aria-hidden="true"></span>
                                </button>
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className={`card mb-3 d-none d-lg-block`}>
                                    <div className="card-body d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6 className="card-title">{client.Name}</h6>
                                            <span className='card-text fs-16'>
                                                <span>{client.Age ? `Age: ${client.Age} | ` : ''}Contact: {client.Contact1}{client.Contact2 ? `, ${client.Contact2}` : ''}</span><br></br>
                                                <span>{client.City ? `City: ${client.City}` : ''}{client.State ? `${client.City ? ' | ' : ''}State: ${client.State}` : ''}</span><br></br>
                                                <span>{client.Language ? `Language: ${client.Language}` : ''}{client.SumAssured ? `${client.Language ? ' | ' : ''}Sum Assured: ${client.SumAssured}` : ''}</span><br></br>
                                                <span>Type: {client.Type}</span><br></br>
                                                <span>{client.Remark ? `Remark: ${client.Remark}` : ''}</span><br></br>
                                                <span><small><strong>Received Date: {moment(client.CreatedDate).format('DD MMM hh:mm A')}</strong></small></span>
                                            </span>
                                        </div>
                                        <div>
                                            <span className={`badge rounded-pill bg-${client.Status == 'Success' ? 'success' : client.Status == 'QC Pending' ? 'info' : client.Status == 'Scheduled' ? 'blue' : client.Status == 'Assigned' ? 'secondary' : 'warning'} me-5`}>{client.Status}</span>
                                        </div>
                                    </div>
                                     <div className="card-footer d-flex justify-content-between align-items-center fs-16">
                                        <span><span className={`badge bg-${client.TestType == 'VMER' ? 'primary' : 'info'} me-2`}>{client.TestType}</span> Proposal No: {client.ProposalNo}</span>
                                        <span>Division: {client.Division} | Branch Code: {client.BranchCode}</span>
                                    </div>
                                </div>

                                <div className={`card mb-3 d-lg-none`}>
                                    <div className="card-body">
                                        <h6 className="card-title">{client.Name}</h6>
                                        <span className='card-text fs-16'>
                                            <span>{client.Age ? `Age: ${client.Age} | ` : ''}Contact: {client.Contact1}{client.Contact2 ? `, ${client.Contact2}` : ''}</span><br></br>
                                            <span>{client.City ? `City: ${client.City}` : ''}{client.State ? `${client.City ? ' | ' : ''}State: ${client.State}` : ''}</span><br></br>
                                            <span>{client.Language ? `Language: ${client.Language}` : ''}</span><br></br>
                                            <span>{client.SumAssured ? `Sum Assured: ${client.SumAssured}` : ''}</span><br></br>
                                            <span>Type: {client.Type}</span><br></br>
                                            <span>{client.Remark ? `Remark: ${client.Remark}` : ''}</span><br></br>
                                            <span><small><strong>Received Date: {moment(client.CreatedDate).format('DD MMM hh:mm A')}</strong></small></span>
                                        </span><br></br>
                                        <span className={`badge rounded-pill bg-${client.Status == 'Success' ? 'success' : client.Status == 'QC Pending' ? 'info' : client.Status == 'Scheduled' ? 'blue' : client.Status == 'Assigned' ? 'secondary' : 'warning'} mt-3 me-2`}>{client.Status}</span>                               
                                    </div>
                                    <div className="card-footer footer-white fs-16">
                                        <span>Division: {client.Division}</span><br></br>
                                        <span>Branch Code: {client.BranchCode}</span>
                                    </div>
                                    <div className="card-footer fs-16">
                                        <span><span className={`badge bg-${client.TestType == 'VMER' ? 'primary' : 'info'} me-2`}>{client.TestType}</span> Proposal No: {client.ProposalNo}</span>
                                    </div>
                                </div>

                                {tpa && (
                                    <div className="card border-light mb-3" style={{backgroundColor: '#eff3f7'}}>
                                        <div className="card-body d-flex justify-content-between align-items-center ms-2 padding-tb10">
                                            <div className='flex-shrink-0'>
                                                {tpa.Logo && tpa.Logo != '' ?
                                                    <img src={`${imgUrl}${tpa.Logo}`} alt="image" className="rounded-circle me-2" width="40" height="40"/> :
                                                    <div className="initial-circle-2x me-2">
                                                        {tpa.Name[0]}
                                                    </div>
                                                }  
                                            </div>
                                            <div className="ms-2 flex-grow-1">
                                                <h6 className="card-title fs-14 mb-1">{tpa.Name}</h6>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {!doctor ? (
                                    <div className="card border-light mb-3" data-bs-toggle="modal" data-bs-target="#scheduleModal" style={{backgroundColor: '#eff3f7', cursor: 'pointer'}}>
                                        <div className="card-body d-flex justify-content-between align-items-center ms-2">
                                            <div>
                                                <span className='fs-14 fw-semibold me-3' style={{color:'#767676'}}><i className="bi bi-clock-fill me-2" style={{color:'#4582ec'}}></i>Click here to schedule</span>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div 
                                            className="card border-light mb-4" 
                                            onClick={() => fillSchedule(client)}
                                            data-bs-toggle={`${client.Status == 'Assigned' || client.Status == "Scheduled" ? 'modal' : ''}`} 
                                            data-bs-target={`${client.Status == 'Assigned' || client.Status == "Scheduled" ? '#scheduleModal' : ''}`} 
                                            style={{backgroundColor: '#eff3f7', cursor: `${client.Status == 'Assigned' || client.status == 'Scheduled' ? 'pointer' : 'default'}`}}
                                        >
                                            <div className="card-body d-flex justify-content-between align-items-center ms-2">
                                                <div className='flex-shrink-0'>
                                                    {doctor.Photo && doctor.Photo != '' ?
                                                        <img src={`${imgUrl}${doctor.Photo}`} alt="image" className="rounded-circle me-2" width="40" height="40"/> :
                                                        <div className="initial-circle-2x me-2">
                                                            {doctor.Name[0]}
                                                        </div>
                                                    }  
                                                </div>
                                                <div className="ms-2 flex-grow-1" style={{ lineHeight: '1' }}>
                                                    <h6 className="card-title fs-14 mb-1">Dr. {doctor.Name}</h6>
                                                    <span className='card-text fs-13'>
                                                        <span><i className="bi bi-telephone text-primary"></i> {doctor.Contact}</span><br/>
                                                        <span><i className="bi bi-envelope text-primary"></i> {doctor.Email}</span>
                                                    </span>
                                                </div>
                                                <div className='d-none d-lg-block'>
                                                    <span className='fs-14 fw-semibold me-3' style={{color:'#767676'}}><i className="bi bi-clock-fill me-2" style={{color:'#4582ec'}}></i>{schedule ? (moment(schedule.Date).format('DD MMM') + ' ' + schedule.From + ' - ' + schedule.To) : 'Click here to schedule'}</span>
                                                </div>
                                            </div>
                                            <div className="card-footer d-lg-none" style={{backgroundColor: '#eff3f7'}}>
                                                <span className='fs-14 fw-semibold ms-3' style={{color:'#767676'}}><i className="bi bi-clock-fill me-2" style={{color:'#4582ec'}}></i>{schedule ? (moment(schedule.Date).format('DD MMM') + ' ' + schedule.From + ' - ' + schedule.To) : 'Click here to schedule'}</span>
                                            </div>
                                        </div>

                                        {(client.Status == 'QC Pending' || client.Status == 'Success') && (
                                            <div className='row mb-4 justify-content-center'>
                                                <div className='col-lg-3 col-6 mb-3'>
                                                    <button type="button" data-bs-toggle="modal" data-bs-target={client.TestType === 'JMER' ? '#juvenileFormModal' : '#formModal'} onClick={() => viewForm(client.ID)} className="btn btn-outline-primary w-100"><i className="bi bi-ui-checks me-2"></i>View Form</button>
                                                </div>
                                                <div className='col-lg-3 col-6 mb-3'>
                                                    <button type="button" className="btn btn-outline-primary w-100" onClick={() => downloadAndOpenPDFHandler(client.ID)}><i className="bi bi-filetype-pdf me-2"></i>View PDF</button>
                                                </div>
                                                {(client.TestType == 'VMER' || client.TestType == 'JMER') && (
                                                    <div className='col-lg-3 col-6 mb-3'>
                                                        <button type="button" className="btn btn-outline-info w-100" data-bs-toggle="modal" data-bs-target="#videoModal" onClick={() => handleDownloadVideo(client.ID)}><i className="bi bi-play-circle me-2"></i>Play Video</button>
                                                    </div>
                                                )}
                                                <div className='col-lg-3 col-6 mb-3'>
                                                    <button type="button" className="btn btn-outline-success w-100" onClick={verifyClient}><i className="bi bi-check-circle me-2"></i>{client.Status == 'Success' ? 'Verified' : 'Verify'}</button>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}

                                {comments.length > 0 && comments.map((m, i) => (
                                    <div key={m.ID} className="toast show mb-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                                        <div className="toast-header">
                                            {m.Photo && m.Photo != '' ?
                                                <img src={`${imgUrl}${m.Photo}`} alt="image" className="rounded-circle me-2" width="28" height="28"/> :
                                                <div className="initial-circle me-2" style={{ backgroundColor: getColorForUserId(m.UserType == 'Doctor' ? m.UserID + 1 : m.UserID) }}>
                                                    {m.UserName[0]}
                                                </div>
                                            }
                                            <strong className="me-auto">{m.UserName} {m.UserType == 'Doctor' && <i className="fi fi-rr-stethoscope text-primary ms-1"></i>}</strong>                
                                            {(auth.id == m.UserID && m.UserType == 'Admin') && (
                                                <button onClick={() => removeComment(m.ID)} type="button" className="btn btn-outline-danger btn-sm me-2">
                                                    <i className="bi bi-trash"></i>
                                                </button>
                                            )}
                                            <small className='fw-semibold'>{moment(m.CreatedDate).format("DD MMM hh:mm A")}</small>
                                        </div>
                                        <div className="toast-body">
                                            {m.Comment}
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                        <div className="modal-footer d-flex justify-content-between align-items-center" style={{backgroundColor:'#edf2fa'}}>
                            <input id='txtComment' type="text" className="form-control flex-grow-1 me-2" placeholder="Comments" style={{ flex: 1, marginRight: '10px' }}/>
                            <button onClick={sendComment} type="button" className="btn btn-primary"><i className="bi bi-send"></i></button>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={resetData}>Close</button>
                            <button type="button" className="btn btn-success"><i className="bi bi-whatsapp me-2"></i>Whatsapp</button>
                            <button type="button" className="btn btn-info"><i className="bi bi-envelope me-2"></i>Email</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id='addModal' className="modal modal-lg fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">{(!client.ID || client.ID == 0) ? 'Add' : 'Update'} Client</h6>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <form id='clientForm' className={`row mt-3 needs-validation ${validated ? "was-validated" : ""}`} noValidate onSubmit={postClientData}>
                                    <div className='col-md-12 mb-4'>
                                        <div className='input-group'>
                                            <span className='input-group-text'>TPA</span>
                                            <select value={client.TPAID} onChange={({ target }) => handleData('TPAID', target.value)} className="form-select">
                                                {props.tpaList.length > 0 && props.tpaList.map(m => (
                                                    <option key={m.ID} value={m.ID}>{m.Name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('ProposalNo', target.value)}
                                                value={ client.ProposalNo || '' }
                                                id="txtProposalNo" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='proposalNo' 
                                                required
                                            />
                                            <label htmlFor="txtProposalNo">Proposal No</label>
                                            <div className="invalid-feedback">Please enter proposal no.</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <select value={client.Type || ''} onChange={({ target }) => handleData('Type', helper.type(target.value))} className="form-select" id="ddlType">
                                                <option value={'NB'}>NB</option>
                                                <option value={'Revival'}>Revival</option>
                                                <option value={'PWB'}>PWB</option>
                                                <option value={'Outstation'}>Outstation</option>
                                            </select>
                                            <label htmlFor="ddlType">Type</label>
                                        </div>
                                    </div>
                                    <div className='col-md-12 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Name', helper.camelCase(target.value))}
                                                value={ client.Name || '' }
                                                id="txtClientName" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='clientName' 
                                                required
                                            />
                                            <label htmlFor="txtClientName">Client Name</label>
                                            <div className="invalid-feedback">Please enter client name.</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Contact1', helper.contact(target.value))}
                                                value={ client.Contact1 || '' }
                                                id="txtContactNo" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='contactNo' 
                                                required
                                            />
                                            <label htmlFor="txtContactNo">Contact No</label>
                                            <div className="invalid-feedback">Please enter contact no.</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Contact2', helper.contact(target.value))}
                                                value={ client.Contact2 || '' }
                                                id="txtContactNo2" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='contactNo2' 
                                            />
                                            <label htmlFor="txtContactNo2">Contact No 2</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Age', target.value)}
                                                value={ client.Age || '' }
                                                id="txtAge" 
                                                type="number" 
                                                className="form-control" 
                                                placeholder='age' 
                                            />
                                            <label htmlFor="txtAge">Age</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <select value={client.TestType || 'VMER'} onChange={({ target }) => handleData('TestType', target.value)} className="form-select" id="ddlTestDetails">
                                                <option value={'VMER'}>VMER</option>
                                                <option value={'JMER'}>JMER</option>
                                                <option value={'TMER'}>TMER</option>
                                            </select>
                                            <label htmlFor="ddlTestDetails">Test Details</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input
                                                onChange={({ target }) => handleData('City', helper.camelCase(target.value))}
                                                value={ client.City || '' }
                                                id="txtCity" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='city' 
                                            />
                                            <label htmlFor="txtCity">City</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('State', helper.camelCase(target.value))}
                                                value={ client.State || '' }
                                                id="txtState" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='state' 
                                            />
                                            <label htmlFor="txtState">State</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Email', helper.email(target.value))}
                                                value={ client.Email || '' }
                                                id="txtEmail" 
                                                type="email" 
                                                className="form-control" 
                                                placeholder='email' 
                                            />
                                            <label htmlFor="txtEmail">Email</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Language', helper.camelCase(target.value))}
                                                value={ client.Language || '' }
                                                id="txtLanguage" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='language' 
                                            />
                                            <label htmlFor="txtLanguage">Language</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <select value={client.Division || ''} onChange={({ target }) => handleData('Division', target.value)} className="form-select" id="ddlDivision">
                                                <option value={'DO-ALIGARH'}>DO-ALIGARH</option>
                                                <option value={'ASANSOL DO'}>ASANSOL DO</option>
                                                <option value={'AURANGABAD DO'}>AURANGABAD DO</option>
                                                <option value={'BANGLORE DO-II'}>BANGLORE DO-II</option>
                                                <option value={'BARDHAMAN DO'}>BARDHAMAN DO</option>
                                                <option value={'BELGAUM DO'}>BELGAUM DO</option>
                                                <option value={'KMDO II'}>KMDO II</option>
                                                <option value={'CHENNAI DO-I'}>CHENNAI DO-I</option>
                                                <option value={'CHENNAI DO-II'}>CHENNAI DO-II</option>
                                                <option value={'COIMBATORE DO'}>COIMBATORE DO</option>
                                                <option value={'DEHRADUN DO'}>DEHRADUN DO</option>
                                                <option value={'DHARWAD DO'}>DHARWAD DO</option>
                                                <option value={'ERNAKULAM DO'}>ERNAKULAM DO</option>
                                                <option value={'DO-FAIZABAD'}>DO-FAIZABAD</option>
                                                <option value={'DO-GORAKHPUR'}>DO-GORAKHPUR</option>
                                                <option value={'DO-HALDWANI'}>DO-HALDWANI</option>
                                                <option value={'INDORE DO'}>INDORE DO</option>
                                                <option value={'JABALPUR DO'}>JABALPUR DO</option>
                                                <option value={'JALPIGURI DO'}>JALPIGURI DO</option>
                                                <option value={'JORHAT DO'}>JORHAT DO</option>
                                                <option value={'KARIMNAGAR DO'}>KARIMNAGAR DO</option>
                                                <option value={'KHARAGHPUR DO'}>KHARAGHPUR DO</option>
                                                <option value={'KOLHAPUR DO'}>KOLHAPUR DO</option>
                                                <option value={'KOTTAYAM DO'}>KOTTAYAM DO</option>
                                                <option value={'KOZHI-KODI DO'}>KOZHI-KODI DO</option>
                                                <option value={'MADURAI DO'}>MADURAI DO</option>
                                                <option value={'MUMBAI DO-I'}>MUMBAI DO-I</option>
                                                <option value={'MYSORE DO'}>MYSORE DO</option>
                                                <option value={'NASHIK DO'}>NASHIK DO</option>
                                                <option value={'PUNE DO-II'}>PUNE DO-II</option>
                                                <option value={'RAICHUR DO'}>RAICHUR DO</option>
                                                <option value={'RAJKOT DO'}>RAJKOT DO</option>
                                                <option value={'SALEM DO'}>SALEM DO</option>
                                                <option value={'SATARA DO'}>SATARA DO</option>
                                                <option value={'SHIMOGA DO'}>SHIMOGA DO</option>
                                                <option value={'SILCHAR DO'}>SILCHAR DO</option>
                                                <option value={'SURAT DO'}>SURAT DO</option>
                                                <option value={'TECH-TERM'}>TECH-TERM</option>
                                                <option value={'THANE DO'}>THANE DO</option>
                                                <option value={'THANJAVUR DO'}>THANJAVUR DO</option>
                                                <option value={'THRISSUR DO'}>THRISSUR DO</option>
                                                <option value={'TIRUNELVELI DO'}>TIRUNELVELI DO</option>
                                                <option value={'TRIVANADRUM DO'}>TRIVANADRUM DO</option>
                                                <option value={'UDUPI DO'}>UDUPI DO</option>
                                                <option value={'VADODARA DO'}>VADODARA DO</option>
                                                <option value={'VELLORE DO'}>VELLORE DO</option>
                                                <option value={'VISAKHAPATNAM DO'}>VISAKHAPATNAM DO</option>
                                                <option value={'WARANGAL DO'}>WARANGAL DO</option>
                                                <option value={'DO-BAREILLY'}>DO-BAREILLY</option>
                                                <option value={'AHMEDABAD DO'}>AHMEDABAD DO</option>
                                                <option value={'BANGLORE DO-I'}>BANGLORE DO-I</option>
                                                <option value={'KSDO'}>KSDO</option>
                                                <option value={'MUMBAI DO-III'}>MUMBAI DO-III</option>
                                                <option value={'VARANASI DO'}>VARANASI DO</option>
                                                <option value={'LUCKNOW DO'}>LUCKNOW DO</option>
                                                <option value={'KANPUR DO'}>KANPUR DO</option>
                                                <option value={'PRYAGRAJ DO'}>PRYAGRAJ DO</option>
                                                <option value={'ALLAHABAD DO'}>ALLAHABAD DO</option>
                                                <option value={'AYODHYA DO'}>AYODHYA DO</option>
                                                <option value={'RAIPUR DO'}>RAIPUR DO</option>
                                                <option value={'BILASPUR DO'}>BILASPUR DO</option>
                                                <option value={'SATNA DO'}>SATNA DO</option>
                                                <option value={'SHAHDOL DO'}>SHAHDOL DO</option>
                                                <option value={'GWALIOR DO'}>GWALIOR DO</option>
                                                <option value={'BHOPAL DO'}>BHOPAL DO</option>
                                                <option value={'HYDERABAD DO'}>HYDERABAD DO</option>
                                                <option value={'MACHILIPATNAM DO'}>MACHILIPATNAM DO</option>
                                                <option value={'SECUNDERABAD DO'}>SECUNDERABAD DO</option>
                                                <option value={'OTHERS'}>OTHERS</option>
                                            </select>
                                            <label htmlFor="ddlDivision">Division</label>
                                        </div>
                                    </div>
                                    {client.Division == 'OTHERS' && (
                                        <div className='col-md-6 mb-3'>
                                            <div className="form-floating">
                                                <input 
                                                    onChange={({ target }) => handleData('M-Division', helper.camelCase(target.value))}
                                                    value={ client['M-Division'] || '' }
                                                    id="txtDivision" 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder='division'
                                                    required
                                                />
                                                <label htmlFor="txtDivision">Enter Division</label>
                                                <div className="invalid-feedback">Please enter division.</div>
                                            </div>
                                        </div>
                                    )}
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('BranchCode', target.value)}
                                                value={ client.BranchCode || '' }
                                                id="txtBranchCode" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='branchCode'
                                                required
                                            />
                                            <label htmlFor="txtBranchCode">Branch Code</label>
                                            <div className="invalid-feedback">Please enter branch code.</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('SumAssured', target.value)}
                                                value={ client.SumAssured || '' }
                                                id="txtSumAssured" 
                                                type="number" 
                                                className="form-control" 
                                                placeholder='sumAssured'
                                            />
                                            <label htmlFor="txtSumAssured">Sum Assured</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Remark', target.value)}
                                                value={ client.Remark || '' }
                                                id="txtRemark" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='remark'
                                            />
                                            <label htmlFor="txtRemark">Remark</label>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="submit" form='clientForm' className="btn btn-primary">Save</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id='uploadModal' className="modal modal-xl fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">Upload New Clients</h6>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {clientList.length > 0 || clientList1.length > 0 ? (
                                    <div>
                                        {clientList1.filter(f => f.Message != 'Duplicate record').length > 0 && (
                                            <table className="table table-bordered mt-3">
                                                <thead>
                                                    <tr className='table-active'>
                                                        <th colSpan={15} className="text-center align-middle">Incorrect Records</th>
                                                    </tr>
                                                    <tr className='table-active'>
                                                        <th className="text-center align-middle">Status</th>
                                                        <th className="text-center align-middle">Proposal No</th>
                                                        <th className="text-center align-middle">Type</th>
                                                        <th className="text-center align-middle">Client Name</th>
                                                        <th className="text-center align-middle">Age</th>
                                                        <th className="text-center align-middle">Contact No</th>
                                                        <th className="text-center align-middle">Contact No 2</th>
                                                        <th className="text-center align-middle">Test Details</th>
                                                        <th className="text-center align-middle">City</th>
                                                        <th className="text-center align-middle">State</th>
                                                        <th className="text-center align-middle">Email</th>
                                                        <th className="text-center align-middle">Language</th>
                                                        <th className="text-center align-middle">Division</th>
                                                        <th className="text-center align-middle">Branch Code</th>
                                                        <th className="text-center align-middle">Sum Assured</th>
                                                        <th className="text-center align-middle">Remark</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {clientList1.filter(f => f.Message != 'Duplicate record').map((m, i) => (
                                                        <tr key={i}>
                                                            <td className="text-center align-middle">
                                                                <i 
                                                                    className="bi bi-exclamation-circle text-warning" 
                                                                    data-tip="Tooltip"
                                                                    data-for={`tooltip-status-${i}`}>
                                                                </i>
                                                                <ReactTooltip id={`tooltip-status-${i}`}  place="right" effect="solid">
                                                                    {m.Message}
                                                                </ReactTooltip>
                                                            </td>
                                                            <td className="text-center align-middle">{m.ProposalNo}</td>
                                                            <td className="text-center align-middle">{m.Type}</td>
                                                            <td className="align-middle">{m.Name}</td>
                                                            <td className="text-center align-middle">{m.Age}</td>
                                                            <td className="text-center align-middle">{m.Contact1}</td>
                                                            <td className="text-center align-middle">{m.Contact2}</td>
                                                            <td className="text-center align-middle">{m.TestType}</td>
                                                            <td className="text-center align-middle">{m.City}</td>
                                                            <td className="text-center align-middle">{m.State}</td>
                                                            <td className="text-center align-middle">{m.Email}</td>
                                                            <td className="text-center align-middle">{m.Language}</td>
                                                            <td className="text-center align-middle">{m.Division}</td>
                                                            <td className="text-center align-middle">{m.BranchCode}</td>
                                                            <td className="text-center align-middle">{m.SumAssured}</td>
                                                            <td className="align-middle">{m.Remark}</td>
                                                        </tr>
                                                    ))}

                                                </tbody>
                                            </table>
                                        )}

                                        {clientList1.filter(f => f.Message == 'Duplicate record').length > 0 && (
                                            <>
                                                <table className="table table-bordered mt-4">
                                                    <thead>
                                                        <tr className='table-active'>
                                                            <th colSpan={16} className="text-center align-middle padding-tb10">
                                                                <div className="d-flex justify-content-center align-items-center position-relative">
                                                                    <div className="position-absolute start-0">
                                                                        <button onClick={() => resolveAllDuplicate()} data-tip="Tooltip" data-for='tooltip-action-all' type="button" className="btn btn-outline-primary btn-sm me-2">
                                                                            <i className="bi bi-upload me-1"></i> Upload All
                                                                        </button> 
                                                                        <ReactTooltip id='tooltip-action-all'  place="right" effect="solid">
                                                                            Upload all anyway
                                                                        </ReactTooltip>
                                                                    </div>
                                                                    <span>Duplicate Records</span>
                                                                </div>
                                                                
                                                               
                                                            </th>
                                                        </tr>
                                                        <tr className='table-active'>
                                                            <th className="text-center align-middle">Status</th>
                                                            <th className="text-center align-middle">Action</th>
                                                            <th className="text-center align-middle">Proposal No</th>
                                                            <th className="text-center align-middle">Type</th>
                                                            <th className="text-center align-middle">Client Name</th>
                                                            <th className="text-center align-middle">Age</th>
                                                            <th className="text-center align-middle">Contact No</th>
                                                            <th className="text-center align-middle">Contact No 2</th>
                                                            <th className="text-center align-middle">Test Details</th>
                                                            <th className="text-center align-middle">City</th>
                                                            <th className="text-center align-middle">State</th>
                                                            <th className="text-center align-middle">Email</th>
                                                            <th className="text-center align-middle">Language</th>
                                                            <th className="text-center align-middle">Division</th>
                                                            <th className="text-center align-middle">Branch Code</th>
                                                            <th className="text-center align-middle">Sum Assured</th>
                                                            <th className="text-center align-middle">Remark</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {clientList1.filter(f => f.Message == 'Duplicate record').map((m, i) => (
                                                            <tr key={i}>
                                                                <td className="text-center align-middle">
                                                                    <i 
                                                                        className="bi bi-exclamation-circle text-warning" 
                                                                        data-tip="Tooltip"
                                                                        data-for='tooltip-duplicate'>
                                                                    </i>
                                                                </td>
                                                                <td className="text-center align-middle">
                                                                    <button onClick={() => resolveDuplicate(i)} data-tip="Tooltip" data-for='tooltip-action' type="button" className="btn btn-outline-primary btn-sm me-2">
                                                                        <i className="bi bi-upload"></i>
                                                                    </button> 
                                                                </td>
                                                                <td className="text-center align-middle">{m.ProposalNo}</td>
                                                                <td className="text-center align-middle">{m.Type}</td>
                                                                <td className="align-middle">{m.Name}</td>
                                                                <td className="text-center align-middle">{m.Age}</td>
                                                                <td className="text-center align-middle">{m.Contact1}</td>
                                                                <td className="text-center align-middle">{m.Contact2}</td>
                                                                <td className="text-center align-middle">{m.TestType}</td>
                                                                <td className="text-center align-middle">{m.City}</td>
                                                                <td className="text-center align-middle">{m.State}</td>
                                                                <td className="text-center align-middle">{m.Email}</td>
                                                                <td className="text-center align-middle">{m.Language}</td>
                                                                <td className="text-center align-middle">{m.Division}</td>
                                                                <td className="text-center align-middle">{m.BranchCode}</td>
                                                                <td className="text-center align-middle">{m.SumAssured}</td>
                                                                <td className="align-middle">{m.Remark}</td>
                                                            </tr>
                                                        ))}  
                                                    </tbody>
                                                </table>
                                                <ReactTooltip id='tooltip-duplicate'  place="right" effect="solid">
                                                    Duplicate Record
                                                </ReactTooltip>
                                                <ReactTooltip id='tooltip-action'  place="right" effect="solid">
                                                    Upload anyway
                                                </ReactTooltip>
                                            </>
                                        )}

                                        {clientList.length > 0 && (
                                            <table className="table table-bordered mt-4">
                                                <thead>
                                                    <tr className='table-active'>
                                                        <th colSpan={15} className="text-center align-middle">Data to be uploaded</th>
                                                    </tr>
                                                    <tr className='table-active'>
                                                        <th className="text-center align-middle">Status</th>
                                                        <th className="text-center align-middle">Proposal No</th>
                                                        <th className="text-center align-middle">Type</th>
                                                        <th className="text-center align-middle">Client Name</th>
                                                        <th className="text-center align-middle">Age</th>
                                                        <th className="text-center align-middle">Contact No</th>
                                                        <th className="text-center align-middle">Contact No 2</th>
                                                        <th className="text-center align-middle">Test Details</th>
                                                        <th className="text-center align-middle">City</th>
                                                        <th className="text-center align-middle">State</th>
                                                        <th className="text-center align-middle">Email</th>
                                                        <th className="text-center align-middle">Language</th>
                                                        <th className="text-center align-middle">Division</th>
                                                        <th className="text-center align-middle">Branch Code</th>
                                                        <th className="text-center align-middle">Sum Assured</th>
                                                        <th className="text-center align-middle">Remark</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {clientList.map((m, i) => (
                                                        <tr key={i}>
                                                            <td className="text-center align-middle"><i className="bi bi-check-circle text-success"></i></td>
                                                            <td className="text-center align-middle">{m.ProposalNo}</td>
                                                            <td className="text-center align-middle">{m.Type}</td>
                                                            <td className="align-middle">{m.Name}</td>
                                                            <td className="text-center align-middle">{m.Age}</td>
                                                            <td className="text-center align-middle">{m.Contact1}</td>
                                                            <td className="text-center align-middle">{m.Contact2}</td>
                                                            <td className="text-center align-middle">{m.TestType}</td>
                                                            <td className="text-center align-middle">{m.City}</td>
                                                            <td className="text-center align-middle">{m.State}</td>
                                                            <td className="text-center align-middle">{m.Email}</td>
                                                            <td className="text-center align-middle">{m.Language}</td>
                                                            <td className="text-center align-middle">{m.Division}</td>
                                                            <td className="text-center align-middle">{m.BranchCode}</td>
                                                            <td className="text-center align-middle">{m.SumAssured}</td>
                                                            <td className="align-middle">{m.Remark}</td>
                                                        </tr>
                                                    ))}

                                                </tbody>
                                            </table>
                                        )}

                                    </div>
                                ) : (
                                    <form className='row my-3'>
                                        <div className='col-12 mb-3'>
                                            <div className='input-group'>
                                                <span className='input-group-text'>TPA</span>
                                                <select id='ddlTpa' className="form-select">
                                                    {props.tpaList.length > 0 && props.tpaList.map(m => (
                                                        <option key={m.ID} value={m.ID}>{m.Name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className='col-12 mb-3'>
                                            <div className='input-group'>
                                                <span className='input-group-text'>Test</span>
                                                <select id='ddlTestType' className="form-select fs-16">
                                                    <option value={'VMER'}>VMER</option>
                                                    <option value={'JMER'}>JMER</option>
                                                    <option value={'TMER'}>TMER</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className='col-12 mb-3'>
                                            <input 
                                                className="form-control" 
                                                type="file" 
                                                id="formFile"
                                                accept=".csv, .xlsx, .xls"
                                                onChange={({ target: { files } }) => fileHandler(files[0])}
                                            />
                                        </div>
                                        <div className='col-12 p-4 text-center'>
                                            <span>Please upload only <strong>Excel</strong> or <strong>CSV</strong> file <br></br>You can <a href="/file/clients.xlsx" download>download the file template</a> here</span>

                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" className="btn btn-primary" onClick={postClientListData}>Upload</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id='scheduleModal' className="modal modal-lg fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">Assign Doctor</h6>
                            <button type="button" className="btn-close" data-bs-toggle="modal" data-bs-target="#viewModal" aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className='row'>
                                    <div className='col-md-12 mb-4'>
                                        <div className='input-group'>
                                            <span className='input-group-text'>Doctor</span>
                                            <select id='ddlDoctor' onChange={getDoctorSlots} className="form-select">
                                                {doctors.length > 0 && doctors.map(m => (
                                                    <option key={m.ID} value={m.ID}>{m.Name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='col-md-12 mb-3'>
                                        <div className='input-group'>
                                            <span className='input-group-text'>Date</span>
                                            <input 
                                                onChange={getDoctorSlots}
                                                id="txtDate" 
                                                type="date" 
                                                className="form-control" 
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-12 mb-3 mt-3 text-center'>
                                        {slots.length > 0 && slots.map((m, i) => (
                                            <button 
                                                key={i} 
                                                type="button" 
                                                onClick={() => setSelectedSlot({...m, Index: i})}
                                                className={`btn ${selectedSlot && selectedSlot.Index == i ? 'btn-success' : `btn-outline-${m.Status == 'Available' ? 'primary' : 'secondary disabled'}`} me-3 mt-3`}>
                                                {m.From} - {m.To}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#viewModal">Close</button>
                            {selectedSlot ? 
                                (<button onClick={scheduleClientData} type="button" className="btn btn-primary">Schedule</button>) : 
                                (<button onClick={assignDoctorData} type="button" className="btn btn-primary">Assign</button>)
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="videoModal"
                className="modal fade"
                tabIndex="-1"
                aria-labelledby="modalLabel"
                aria-hidden="true"
                data-bs-backdrop="static" 
                data-bs-keyboard="false"
            >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    {videoURL && (
                        <div className="modal-content" style={{backgroundColor: '#000'}}>
                            <button style={{zIndex: '1'}} type="button" className="position-absolute top-0 end-0 m-3 bg-transparent border-0 text-white" data-bs-toggle="modal" data-bs-target="#viewModal" aria-label="Close">
                                <i className="bi bi-x-lg"></i>
                            </button>
                            <div className="modal-body p-0"> 
                                <video controls autoPlay style={{ width: "100%", height: "100%", borderRadius: '8px' }} src={videoURL} ref={videoRef} />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div id='sendLinkModal' className="modal modal-lg fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">Send Link</h6>
                            <button type="button" className="btn-close" data-bs-toggle="modal" data-bs-target="#viewModal" aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <form id='shareLinkForm' className={`row mt-3 needs-validation ${linkValidated ? "was-validated" : ""}`} noValidate onSubmit={postShareLink}>
                                    <div className='row'>
                                        <div className='col-12 mb-3'>
                                            <Select
                                                value={countryCode}
                                                onChange={(e) => setCountryCode({value: e.value, label: e.label})}
                                                options={helper.countryCodes}
                                            />
                                        </div>
                                        <div className='col-12 mb-3'>
                                            <input
                                                onChange={({ target }) => setMobile(helper.contact(target.value))}
                                                value={mobile || ''}
                                                id="txtMobile" 
                                                type="number"  
                                                className="form-control"
                                                placeholder="Mobile"
                                                required
                                            />
                                            <div className="invalid-feedback">Please enter mobile no.</div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#viewModal">Close</button>
                            <button type="submit" form='shareLinkForm' className="btn btn-success"><i className="bi bi-whatsapp me-2"></i>Whatsapp</button>
                        </div>
                    </div>
                </div>
            </div>


            <div id='formModal' className="modal modal-lg fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">Medical Form</h6>
                            <button type="button" className="btn-close" data-bs-toggle="modal" data-bs-target="#viewModal" aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <form id='medicalForm' className={`row needs-validation ${formValidated ? "was-validated" : ""}`} noValidate onSubmit={(e) => postForm(e, 'VMER')}>
                                    {doctor && (
                                        <div className='col-md-12 text-center'>
                                            <h5>Dr. {doctor.Name}</h5>
                                            <span className="col-form-label mb-2">Proposal No: {client.ProposalNo} | Branch Code: {client.BranchCode}</span><br></br>
                                            <span className="col-form-label mb-2">{moment(medicalForm.find((item) => item.QuestionID === 41)?.Answer).format('DD MMMM hh:mm A')}</span>
                                        </div>
                                    )}

                                    <div className='col-md-12 mt-4 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-2">Identity Proof</label>
                                            <div className="form-check mb-2">
                                                <input
                                                    className="form-check-input" 
                                                    type="radio"  
                                                    value="Aadhar Card"
                                                    name="identityProof"
                                                    onChange={({ target }) => handleFormData(1, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 1)?.Answer === "Aadhar Card"
                                                    }
                                                    required
                                                />
                                                <label className="form-check-label">
                                                    Aadhar Card
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="PAN Card"
                                                    name="identityProof"
                                                    onChange={({ target }) => handleFormData(1, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 1)?.Answer === "PAN Card"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    PAN Card
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="Driving Licence"
                                                    name="identityProof"
                                                    onChange={({ target }) => handleFormData(1, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 1)?.Answer === "Driving Licence"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Driving Licence
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="Passport"
                                                    name="identityProof"
                                                    onChange={({ target }) => handleFormData(1, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 1)?.Answer === "Passport"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Passport
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="Employee ID"
                                                    name="identityProof"
                                                    onChange={({ target }) => handleFormData(1, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 1)?.Answer === "Employee ID"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Employee ID
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="Voter ID"
                                                    name="identityProof"
                                                    onChange={({ target }) => handleFormData(1, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 1)?.Answer === "Voter ID"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Voter ID
                                                </label>
                                            </div>
                                        </fieldset>              
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">ID Proof Number (in case of Aadhar only last 4 digits)</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(2, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 2)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer" 
                                            required
                                        />
                                        <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Full name of the life to be assured</label>
                                        <input
                                            onChange={({ target }) => handleFormData(3, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 3)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Date of Birth</label>
                                        <input
                                            onChange={({ target }) => {
                                                const formattedDate = moment(target.value, "YYYY-MM-DD").format("DD/MM/YYYY");
                                                handleFormData(4, formattedDate);
                                            }}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 4)?.Answer
                                                    ? moment(medicalForm.find((item) => item.QuestionID === 4)?.Answer, 'DD/MM/YYYY').format('YYYY-MM-DD')
                                                    : ""
                                            }
                                            type="date" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Age</label>
                                        <input
                                            onChange={({ target }) => handleFormData(5, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 5)?.Answer || ""
                                            }
                                            type="number" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-2">Gender</label>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="gander" 
                                                    value="Male"
                                                    onChange={({ target }) => handleFormData(6, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 6)?.Answer === "Male"
                                                    }
                                                    required
                                                />
                                                <label className="form-check-label">
                                                    Male
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="gander" 
                                                    value="Female"
                                                    onChange={({ target }) => handleFormData(6, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 6)?.Answer === "Female"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Female
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="gander"  
                                                    value="Prefer not to say"
                                                    onChange={({ target }) => handleFormData(6, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 6)?.Answer === "Prefer not to say"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Prefer not to say
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="gander" 
                                                    value="Others"
                                                    onChange={({ target }) => handleFormData(6, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 6)?.Answer === "Others"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Others
                                                </label>
                                            </div>
                                        </fieldset>              
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Height (in cms)</label>
                                        <input
                                            onChange={({ target }) => handleFormData(7, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 7)?.Answer || ""
                                            }
                                            type="number" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Weight (in kgs)</label>
                                        <input
                                            onChange={({ target }) => handleFormData(8, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 8)?.Answer || ""
                                            }
                                            type="number" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether receiving or ever received any treatment/medication including alternate medicine like ayurveda, homeopathy etc</label>
                                        <input
                                            onChange={({ target }) => handleFormData(9, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 9)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Undergone any surgery / hospitalized for any medicalcondition / disability / injury due to accident ?</label>
                                        <input
                                            onChange={({ target }) => handleFormData(10, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 10)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether visited the doctor any time in the last 5 years ? If answer to any of the questions 5(a) to (c) is yes -i. Date of surgery/accident/injury/hospitalisationii. Nature and causeiii.Name of Medicineiv.Degree of impairment if anyv. Whether unconscious due to accident, if yes, give duration</label>
                                        <input
                                            onChange={({ target }) => handleFormData(11, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 11)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">In the last 5 years, if advised to undergo an X-ray/ CT scan / MRI /ECG / TMT / Blood test / Sputum/Throat swab test or any otherinvestigatory or diagnostic tests ? Please specify date , reason ,advised by whom & findings.</label>
                                        <input
                                            onChange={({ target }) => handleFormData(12, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 12)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering or ever suffered from Novel Coronavirus (Covid-19) orexperienced any of the symptoms (for more than 5 days) such asany fever, Cough, Shortness of breath, Malaise (flu-like tiredness),Rhinorrhea (mucus discharge from the nose), Sore throat, Gastrointestinalsymptoms such as nausea, vomiting and/or diarrhoea,Chills, Repeated shaking with chills, Muscle pain, Headache, Loss oftaste or smell within last 14 days. If yes provide all investigation and treatment reports</label>
                                        <input
                                            onChange={({ target }) => handleFormData(13, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 13)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering from Hypertension (high blood pressure) or diabetes or blood sugar levels higher than normal or history of sugar /albuminin urine ?</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(14, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 14)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Since when, any follow up and date and value of last checked blood pressure and sugar levels ?</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(15, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 15)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether on medication ? please give name of the prescribed medicine and dosage</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(16, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 16)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether developed any complications due to diabetes ?</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(17, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 17)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether suffering from any other endocrine disorders such asthyroid disorder etc.?</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(18, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 18)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Any weight gain or weight loss in last 12 months (other than by dietcontrol or exercise) ?</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(19, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 19)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Any history of chest pain, heartattack, palpitations andbreathlessness on exertion or irregular heartbeat ?</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(20, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 20)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether suffering from high cholesterol ?</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(21, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 21)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whetheron medication for any heart ailment/ high cholesterol?Please state name of the prescribed medicine and dosage</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(22, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 22)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether undergone Surgery such as CABG, open heart surgeryor PTCA ?</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(23, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 23)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering or ever suffered from any disease related to kidney suchas kidney failure, kidney or ureteral stones, blood or pus in urine orprostate ?</label>
                                        <input
                                            onChange={({ target }) => handleFormData(24, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 24)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering or ever suffered from any Liver disorders like cirrhosis,hepatitis, jaundice, or disorder of the Spleen or from any lungrelated or respiratory disorders such as Asthma, bronchitis,wheezing, tuberculosis breathing difficulties etc.?</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(25, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 25)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering or ever suffered from any Blood disorder likeanaemia, thalassemia or any Circulatory disorder ?</label>
                                        <input
                                            onChange={({ target }) => handleFormData(26, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 26)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering or ever suffered from any form of cancer, leukaemia,tumor, cyst or growth of any kind or enlarged lymph nodes ?</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(27, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 27)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering or ever suffered from Epilepsy, nervous disorder,multiple sclerosis, tremors, numbness, paralysis, brain stroke ?</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(28, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 28)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering or ever suffered from any physical impairment/disability /amputation or any congenital disease/abnormality ordisorder of back, neck, muscle, joints, bones, arthritis or gout ?</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(29, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 29)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering or ever suffered from Hernia or disorder of theStomach / intestines, colitis, indigestion, Peptic ulcer, piles, or anyother disease of the gall bladder or pancreas ?</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(30, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 30)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">a. Suffering from Depression/Stress/ Anxiety/ Psychosis or any otherMental / psychiatric disorder? b. Whether on treatment or ever taken any treatment, if yes, pleasegive details of treatment, prescribed medicine and dosages</label>
                                        <input
                                            onChange={({ target }) => handleFormData(31, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 31)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Is there any abnormality of Eyes (partial/total blindness),Ears(deafness/ discharge from the ears), Nose, Throat orMouth, teeth, swelling of gums / tongue, tobacco stains or signs oforal cancer ?</label>
                                        <input
                                            onChange={({ target }) => handleFormData(32, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 32)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether person being examined and/ or his/her spouse/partnertested positive or is/ are under treatment for HIV/AIDS/Sexually transmitted diseases (e.g. syphilis, gonorrhea, etc.)</label>
                                        <input
                                            onChange={({ target }) => handleFormData(33, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 33)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Ascertain if any other condition / disease / adverse habit (such assmoking/ tobacco chewing/ consumption ofalcohol/drugs etc) which is relevant in assessent of medical risk ofexaminee. (Type No, If Yes mention details)</label>
                                        <input
                                            onChange={({ target }) => handleFormData(34, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 34)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">For Female: Whether pregnant? If so duration</label>
                                        <input
                                            onChange={({ target }) => handleFormData(35, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 35)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">For Female: Suffering from any pregnancy related complications</label>
                                        <input
                                            onChange={({ target }) => handleFormData(36, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 36)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether consulted a gynaecologist or undergone any investigation,treatment for any gynaec ailment such as fibroid, cyst or any diseaseof the breasts, uterus, cervix or ovaries etc. or taken / taking anytreatment for the same</label>
                                        <input
                                            onChange={({ target }) => handleFormData(37, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 37)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-2">FROM MEDICAL EXAMINER’S OBSERVATION/ASSESSMENT WHETHER LIFE TO BE ASSURED APPEARS MENTALLY ANDPHYSICALLY HEALTHY</label>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="examiner" 
                                                    value="Yes"
                                                    onChange={({ target }) => handleFormData(38, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 38)?.Answer === "Yes"
                                                    }
                                                />
                                                <label className="form-check-label" >
                                                    Yes
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="examiner" 
                                                    value="No"
                                                    onChange={({ target }) => handleFormData(38, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 39)?.Answer === "No"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    No
                                                </label>
                                            </div>
                                        </fieldset>              
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Place</label>
                                        <input
                                            onChange={({ target }) => handleFormData(39, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 39)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    {client.TestType == 'VMER' && (
                                        <> 
                                            <div className='col-md-12 mb-4'>
                                                <label className="col-form-label">Location</label>
                                                <input
                                                    onChange={({ target }) => handleFormData(40, target.value)}
                                                    value={
                                                        medicalForm.find((item) => item.QuestionID === 40)?.Answer || ""
                                                    }
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Your answer"
                                                    required
                                                />
                                                    <div className="invalid-feedback">This is a required question</div>
                                            </div>
                                            <div className="position-relative my-4">
                                                <hr className='my-0'/>
                                                <span className="position-absolute top-50 start-50 translate-middle bg-white px-2 text-muted fs-18">Screenshots</span>
                                            </div>

                                            <div className='col-md-12 mt-4 mb-4'>
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <input 
                                                        className="form-control d-none" 
                                                        type="file" 
                                                        id="fileStamp"
                                                        accept=".png, .jpeg, .jpg"
                                                        onChange={handleFileChange}
                                                    />
                                                    <label htmlFor="fileStamp" className="form-control d-flex justify-content-between align-items-center file-uploader">
                                                        <span>Upload Image</span>
                                                        <span className="upload-icon" style={{ marginLeft: 'auto' }}>
                                                            <i className="bi bi-upload"></i>
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>

                                            {screenShots.filter(f => f.Action != 'D').length > 0 && screenShots.filter(f => f.Action != 'D').map((m, i) => {

                                                const mimeType = m.Action == 'A' ? "image/jpeg" : helper.getMimeType(m.Name);
                                                const blob = m.Action == 'A' ? m.Blob : new Blob([new Uint8Array(m.Buffer.data)], { type: mimeType });
                                                const objectURL = URL.createObjectURL(blob); 

                                                return (
                                                    <div key={i} className='col-md-6 mt-3'>
                                                        <div className="alert alert-dismissible alert-light padding-0 btnCapture">
                                                            <button onClick={() => removeScreenshot(i)} type="button" className="btn-close padding-5 margin-5"></button>
                                                            <img src={objectURL} alt="Screenshot" style={{ width: '100%' }} />
                                                        </div>
                                                    </div>
                                                    
                                                );
                                            })}

                                        </>
                                    )}
                                   
                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#viewModal">Close</button>
                            <button type="submit" form='medicalForm' className="btn btn-success">Submit</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id='juvenileFormModal' className="modal modal-lg fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">Medical Form</h6>
                            <button type="button" className="btn-close" data-bs-toggle="modal" data-bs-target="#viewModal" aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <form id='juvenileMedicalForm' className={`row needs-validation ${formValidated ? "was-validated" : ""}`} noValidate onSubmit={(e) => postForm(e, 'JMER')}>
                                    {doctor && (
                                        <div className='col-md-12 text-center'>
                                            <h5>Dr. {doctor.Name}</h5>
                                            <span className="col-form-label mb-2">Proposal No: {client.ProposalNo} | Branch Code: {client.BranchCode}</span><br></br>
                                            <span className="col-form-label mb-2">{moment(medicalForm.find((item) => item.QuestionID === 41)?.Answer).format('DD MMMM hh:mm A')}</span>
                                        </div>
                                    )}

                                    <div className='col-md-12 mt-4 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-2">Identity Proof of Parent</label>
                                            <div className="form-check mb-2">
                                                <input
                                                    className="form-check-input" 
                                                    type="radio"  
                                                    value="Aadhar Card"
                                                    name="identityProofParent"
                                                    onChange={({ target }) => handleFormData(1, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 1)?.Answer === "Aadhar Card"
                                                    }
                                                    required
                                                />
                                                <label className="form-check-label">
                                                    Aadhar Card
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="PAN Card"
                                                    name="identityProofParent"
                                                    onChange={({ target }) => handleFormData(1, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 1)?.Answer === "PAN Card"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    PAN Card
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="Driving Licence"
                                                    name="identityProofParent"
                                                    onChange={({ target }) => handleFormData(1, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 1)?.Answer === "Driving Licence"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Driving Licence
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="Passport"
                                                    name="identityProofParent"
                                                    onChange={({ target }) => handleFormData(1, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 1)?.Answer === "Passport"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Passport
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="Employee ID"
                                                    name="identityProofParent"
                                                    onChange={({ target }) => handleFormData(1, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 1)?.Answer === "Employee ID"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Employee ID
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="Voter ID"
                                                    name="identityProofParent"
                                                    onChange={({ target }) => handleFormData(1, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 1)?.Answer === "Voter ID"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Voter ID
                                                </label>
                                            </div>
                                        </fieldset>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">ID Proof Number of Parent (in case of Aadhar only last 4 digits)</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(2, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 2)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer" 
                                            required
                                        />
                                        <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Name of Parent</label>
                                        <input
                                            onChange={({ target }) => handleFormData(3, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 3)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-2">Identity Proof of Life to be assured</label>
                                            <div className="form-check mb-2">
                                                <input
                                                    className="form-check-input" 
                                                    type="radio"  
                                                    value="Aadhar Card"
                                                    name="identityProof"
                                                    onChange={({ target }) => handleFormData(4, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 4)?.Answer === "Aadhar Card"
                                                    }
                                                    required
                                                />
                                                <label className="form-check-label">
                                                    Aadhar Card
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="PAN Card"
                                                    name="identityProof"
                                                    onChange={({ target }) => handleFormData(4, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 4)?.Answer === "PAN Card"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    PAN Card
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="Passport"
                                                    name="identityProof"
                                                    onChange={({ target }) => handleFormData(4, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 4)?.Answer === "Passport"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Passport
                                                </label>
                                            </div>
                                        </fieldset>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">ID Proof Number of Life to be assured (in case of Aadhar only last 4 digits)</label>
                                        <input 
                                            onChange={({ target }) => handleFormData(5, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 5)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer" 
                                            required
                                        />
                                        <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Full name of the Life to be assured</label>
                                        <input
                                            onChange={({ target }) => handleFormData(6, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 6)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Date of Birth</label>
                                        <input
                                            onChange={({ target }) => {
                                                const formattedDate = moment(target.value, "YYYY-MM-DD").format("DD/MM/YYYY");
                                                handleFormData(7, formattedDate);
                                            }}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 7)?.Answer
                                                    ? moment(medicalForm.find((item) => item.QuestionID === 7)?.Answer, 'DD/MM/YYYY').format('YYYY-MM-DD')
                                                    : ""
                                            }
                                            type="date" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Age</label>
                                        <input
                                            onChange={({ target }) => handleFormData(8, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 8)?.Answer || ""
                                            }
                                            type="number" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-2">Gender</label>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="gander" 
                                                    value="Male"
                                                    onChange={({ target }) => handleFormData(9, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 9)?.Answer === "Male"
                                                    }
                                                    required
                                                />
                                                <label className="form-check-label">
                                                    Male
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="gander" 
                                                    value="Female"
                                                    onChange={({ target }) => handleFormData(9, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 9)?.Answer === "Female"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Female
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="gander"  
                                                    value="Prefer not to say"
                                                    onChange={({ target }) => handleFormData(9, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 9)?.Answer === "Prefer not to say"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Prefer not to say
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="gander" 
                                                    value="Others"
                                                    onChange={({ target }) => handleFormData(9, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 9)?.Answer === "Others"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Others
                                                </label>
                                            </div>
                                        </fieldset>              
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Height (in cms)</label>
                                        <input
                                            onChange={({ target }) => handleFormData(10, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 10)?.Answer || ""
                                            }
                                            type="number" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Weight (in kgs)</label>
                                        <input
                                            onChange={({ target }) => handleFormData(11, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 11)?.Answer || ""
                                            }
                                            type="number" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-2">Birth History (Please tick the relevant):</label>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="birthHistory" 
                                                    value="FTND"
                                                    onChange={({ target }) => handleFormData(12, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 12)?.Answer === "FTND"
                                                    }
                                                    required
                                                />
                                                <label className="form-check-label">
                                                    FTND
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="birthHistory" 
                                                    value="Forceps"
                                                    onChange={({ target }) => handleFormData(12, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 12)?.Answer === "Forceps"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Forceps
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="birthHistory"  
                                                    value="Caesarean"
                                                    onChange={({ target }) => handleFormData(12, target.value)}
                                                    checked={
                                                        medicalForm.find((item) => item.QuestionID === 12)?.Answer === "Caesarean"
                                                    }
                                                />
                                                <label className="form-check-label">
                                                    Caesarean
                                                </label>
                                            </div>
                                        </fieldset>              
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Presence of any Congenital defects or abnormalities (If Yes, provide details)</label>
                                        <input
                                            onChange={({ target }) => handleFormData(13, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 13)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Is the Life to be assured presently in good health ? (If No, provide details)</label>
                                        <input
                                            onChange={({ target }) => handleFormData(14, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 14)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Does the Life to be assured have any physical / mental disability or deformity ? (If Yes, provide details)</label>
                                        <input
                                            onChange={({ target }) => handleFormData(15, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 15)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Has the Life to be assured been hospitalized and/or has been advised for any treatment/surgery and /or has undergone any general check up in the last five years ? (If Yes, provide details of any tests conducted and treatment if any.)</label>
                                        <input
                                            onChange={({ target }) => handleFormData(16, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 16)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Has the Life to be assured ever been treated or hospitalized for any Heart ailment / cancer / kidney disorder /epilepsy/ mental disorder / diabetes/ gastrointestinal disorder / genito urinary disorder /musculoskeletal disorder/blood disorder / respiratory disorder like Bronchitis or Asthma / congenital or hereditary disorder ? (If Yes, provide details)</label>
                                        <input
                                            onChange={({ target }) => handleFormData(17, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 17)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Is the child’s behaviour/ appearance/ mental ability in line with his/her current age ? (If No, provide details)</label>
                                        <input
                                            onChange={({ target }) => handleFormData(18, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 18)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">If school going, has the Life to be assured taken any sick leave from school in the last 2 years ? (If Yes, provide details)</label>
                                        <input
                                            onChange={({ target }) => handleFormData(19, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 19)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Please give details of the Life to be assured’s family history: <br></br>Is any family member/s either suffering or have suffered or have died from heart disease, thallassemia, cancer kidney disease, any other hereditary / familial disorders <br></br>(Father / Mother / Sibling 1 / Sibling 2)</label>
                                        <input
                                            onChange={({ target }) => handleFormData(20, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 20)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-0'>
                                        <label className="col-form-label">Immunization History (Mandatory for ages less than and equal to 5 years)</label>
                                    </div>

                                    <div className='col-md-12 mb-1'>
                                        <label className="col-form-label">Vaccinated for</label>
                                    </div>

                                    <div className='col-md-12 mb-2'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">i. OPV:</label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="opv"
                                                        onChange={({ target }) => handleFormData(21, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 21)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="opv"
                                                        onChange={({ target }) => handleFormData(21, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 21)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="NA"
                                                        name="opv"
                                                        onChange={({ target }) => handleFormData(21, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 21)?.Answer === "NA"
                                                        }
                                                    />
                                                    <label className="form-check-label">NA</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    <div className='col-md-12 mb-2'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">ii. DPT:</label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="dpt"
                                                        onChange={({ target }) => handleFormData(22, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 22)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="dpt"
                                                        onChange={({ target }) => handleFormData(22, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 22)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="NA"
                                                        name="dpt"
                                                        onChange={({ target }) => handleFormData(22, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 22)?.Answer === "NA"
                                                        }
                                                    />
                                                    <label className="form-check-label">NA</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    <div className='col-md-12 mb-2'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">iii. BCG:</label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="bcg"
                                                        onChange={({ target }) => handleFormData(23, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 23)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="bcg"
                                                        onChange={({ target }) => handleFormData(23, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 23)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="NA"
                                                        name="bcg"
                                                        onChange={({ target }) => handleFormData(23, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 23)?.Answer === "NA"
                                                        }
                                                    />
                                                    <label className="form-check-label">NA</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    <div className='col-md-12 mb-2'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">iv. Hepatitis B:</label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="hepatitisB"
                                                        onChange={({ target }) => handleFormData(24, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 24)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="hepatitisB"
                                                        onChange={({ target }) => handleFormData(24, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 24)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="NA"
                                                        name="hepatitisB"
                                                        onChange={({ target }) => handleFormData(24, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 24)?.Answer === "NA"
                                                        }
                                                    />
                                                    <label className="form-check-label">NA</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    <div className='col-md-12 mb-2'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">v. Mumps, Measles Rubella:</label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="mumps"
                                                        onChange={({ target }) => handleFormData(25, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 25)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="mumps"
                                                        onChange={({ target }) => handleFormData(25, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 25)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="NA"
                                                        name="mumps"
                                                        onChange={({ target }) => handleFormData(25, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 25)?.Answer === "NA"
                                                        }
                                                    />
                                                    <label className="form-check-label">NA</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    <div className='col-md-12 mb-2'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">vi. Typhoid (above 1 year):</label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="typhoid"
                                                        onChange={({ target }) => handleFormData(26, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 26)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="typhoid"
                                                        onChange={({ target }) => handleFormData(26, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 26)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="NA"
                                                        name="typhoid"
                                                        onChange={({ target }) => handleFormData(26, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 26)?.Answer === "NA"
                                                        }
                                                    />
                                                    <label className="form-check-label">NA</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">vii. Hepatitis A (above 1 year):</label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="hepatitisA"
                                                        onChange={({ target }) => handleFormData(27, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 27)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="hepatitisA"
                                                        onChange={({ target }) => handleFormData(27, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 27)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="NA"
                                                        name="hepatitisA"
                                                        onChange={({ target }) => handleFormData(27, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 27)?.Answer === "NA"
                                                        }
                                                    />
                                                    <label className="form-check-label">NA</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    <div className='col-md-12 mb-0'>
                                        <label className="col-form-label">Do you find any evidence of any abnormality, disease or surgeryof the following <br></br>(If yes, please elaborate):</label>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">The respiratory system ?</label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="respiratorySystem"
                                                        onChange={({ target }) => handleFormData(28, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 28)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="respiratorySystem"
                                                        onChange={({ target }) => handleFormData(28, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 28)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    {medicalForm.find((item) => item.QuestionID === 28)?.Answer === "Yes" && (
                                        <div className='col-md-12 mb-4'>   
                                            <input
                                                onChange={({ target }) => handleElaboration(28, target.value)}
                                                value={
                                                    medicalForm.find((item) => item.QuestionID === 28)?.Elaboration || ""
                                                }
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Please elaborate"
                                                required
                                            />
                                                <div className="invalid-feedback">This is a required question</div>
                                        </div>
                                    )}

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">The central and peripheral nervous system ?</label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="nervousSystem"
                                                        onChange={({ target }) => handleFormData(29, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 29)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="nervousSystem"
                                                        onChange={({ target }) => handleFormData(29, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 29)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    {medicalForm.find((item) => item.QuestionID === 29)?.Answer === "Yes" && (
                                        <div className='col-md-12 mb-4'>   
                                            <input
                                                onChange={({ target }) => handleElaboration(29, target.value)}
                                                value={
                                                    medicalForm.find((item) => item.QuestionID === 29)?.Elaboration || ""
                                                }
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Please elaborate"
                                                required
                                            />
                                                <div className="invalid-feedback">This is a required question</div>
                                        </div>
                                    )}

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">The genito urinary system ?</label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="genitoUrinarySystem"
                                                        onChange={({ target }) => handleFormData(30, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 30)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="genitoUrinarySystem"
                                                        onChange={({ target }) => handleFormData(30, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 30)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    {medicalForm.find((item) => item.QuestionID === 30)?.Answer === "Yes" && (
                                        <div className='col-md-12 mb-4'>   
                                            <input
                                                onChange={({ target }) => handleElaboration(30, target.value)}
                                                value={
                                                    medicalForm.find((item) => item.QuestionID === 30)?.Elaboration || ""
                                                }
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Please elaborate"
                                                required
                                            />
                                                <div className="invalid-feedback">This is a required question</div>
                                        </div>
                                    )}

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">The gastrointestinal system ?</label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="gastrointestinalSystem"
                                                        onChange={({ target }) => handleFormData(31, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 31)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="gastrointestinalSystem"
                                                        onChange={({ target }) => handleFormData(31, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 31)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    {medicalForm.find((item) => item.QuestionID === 31)?.Answer === "Yes" && (
                                        <div className='col-md-12 mb-4'>   
                                            <input
                                                onChange={({ target }) => handleElaboration(31, target.value)}
                                                value={
                                                    medicalForm.find((item) => item.QuestionID === 31)?.Elaboration || ""
                                                }
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Please elaborate"
                                                required
                                            />
                                                <div className="invalid-feedback">This is a required question</div>
                                        </div>
                                    )}

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">The head, face, mouth, throat, eyes, ears, nose and neck ? </label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="headFaceMouthThroatEyesEarsNoseNeck"
                                                        onChange={({ target }) => handleFormData(32, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 32)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="headFaceMouthThroatEyesEarsNoseNeck"
                                                        onChange={({ target }) => handleFormData(32, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 32)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    {medicalForm.find((item) => item.QuestionID === 32)?.Answer === "Yes" && (
                                        <div className='col-md-12 mb-4'>   
                                            <input
                                                onChange={({ target }) => handleElaboration(32, target.value)}
                                                value={
                                                    medicalForm.find((item) => item.QuestionID === 32)?.Elaboration || ""
                                                }
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Please elaborate"
                                                required
                                            />
                                                <div className="invalid-feedback">This is a required question</div>
                                        </div>
                                    )}

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">The skin, muscles, musculoskeletal system ?</label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="skinMusclesMusculoskeletalSystem"
                                                        onChange={({ target }) => handleFormData(33, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 33)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="skinMusclesMusculoskeletalSystem"
                                                        onChange={({ target }) => handleFormData(33, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 33)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    {medicalForm.find((item) => item.QuestionID === 33)?.Answer === "Yes" && (
                                        <div className='col-md-12 mb-4'>   
                                            <input
                                                onChange={({ target }) => handleElaboration(33, target.value)}
                                                value={
                                                    medicalForm.find((item) => item.QuestionID === 33)?.Elaboration || ""
                                                }
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Please elaborate"
                                                required
                                            />
                                                <div className="invalid-feedback">This is a required question</div>
                                        </div>
                                    )}

                                     <div className='col-md-12 mb-0'>
                                        <label className="col-form-label">The Cardiovascular system :</label>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">Are the peripheral pulses abnormal ? </label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="peripheralPulses"
                                                        onChange={({ target }) => handleFormData(34, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 34)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="peripheralPulses"
                                                        onChange={({ target }) => handleFormData(34, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 34)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    {medicalForm.find((item) => item.QuestionID === 34)?.Answer === "Yes" && (
                                        <div className='col-md-12 mb-4'>   
                                            <input
                                                onChange={({ target }) => handleElaboration(34, target.value)}
                                                value={
                                                    medicalForm.find((item) => item.QuestionID === 34)?.Elaboration || ""
                                                }
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Please elaborate"
                                                required
                                            />
                                                <div className="invalid-feedback">This is a required question</div>
                                        </div>
                                    )}

                                     <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">Is there any evidence of heart enlargement ?</label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="heartEnlargement"
                                                        onChange={({ target }) => handleFormData(35, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 35)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="heartEnlargement"
                                                        onChange={({ target }) => handleFormData(35, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 35)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    {medicalForm.find((item) => item.QuestionID === 35)?.Answer === "Yes" && (
                                        <div className='col-md-12 mb-4'>   
                                            <input
                                                onChange={({ target }) => handleElaboration(35, target.value)}
                                                value={
                                                    medicalForm.find((item) => item.QuestionID === 35)?.Elaboration || ""
                                                }
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Please elaborate"
                                                required
                                            />
                                                <div className="invalid-feedback">This is a required question</div>
                                        </div>
                                    )}

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">Are there any murmurs or abnormal heart sounds ?</label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="heartMurmurs"
                                                        onChange={({ target }) => handleFormData(36, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 36)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="heartMurmurs"
                                                        onChange={({ target }) => handleFormData(36, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 36)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    {medicalForm.find((item) => item.QuestionID === 36)?.Answer === "Yes" && (
                                        <div className='col-md-12 mb-4'>   
                                            <input
                                                onChange={({ target }) => handleElaboration(36, target.value)}
                                                value={
                                                    medicalForm.find((item) => item.QuestionID === 36)?.Elaboration || ""
                                                }
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Please elaborate"
                                                required
                                            />
                                                <div className="invalid-feedback">This is a required question</div>
                                        </div>
                                    )}

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-1">Do you suspect any cardiovascular abnormality ?</label>
                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="Yes"
                                                        name="cardiovascularAbnormality"
                                                        onChange={({ target }) => handleFormData(37, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 37)?.Answer === "Yes"
                                                        }
                                                        required
                                                    />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value="No"
                                                        name="cardiovascularAbnormality"
                                                        onChange={({ target }) => handleFormData(37, target.value)}
                                                        checked={
                                                            medicalForm.find((item) => item.QuestionID === 37)?.Answer === "No"
                                                        }
                                                    />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    {medicalForm.find((item) => item.QuestionID === 37)?.Answer === "Yes" && (
                                        <div className='col-md-12 mb-4'>   
                                            <input
                                                onChange={({ target }) => handleElaboration(37, target.value)}
                                                value={
                                                    medicalForm.find((item) => item.QuestionID === 37)?.Elaboration || ""
                                                }
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Please elaborate"
                                                required
                                            />
                                                <div className="invalid-feedback">This is a required question</div>
                                        </div>
                                    )}

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Comments from the Doctor: <br></br>Are there any points on which you suggest further information be obtained in respect of physical investigation or mental level assessment ? (If yes, give details.)</label>
                                        <input
                                            onChange={({ target }) => handleFormData(38, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 38)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Place</label>
                                        <input
                                            onChange={({ target }) => handleFormData(39, target.value)}
                                            value={
                                                medicalForm.find((item) => item.QuestionID === 39)?.Answer || ""
                                            }
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    {client.TestType == 'JMER' && (
                                        <> 
                                            <div className='col-md-12 mb-4'>
                                                <label className="col-form-label">Location</label>
                                                <input
                                                    onChange={({ target }) => handleFormData(40, target.value)}
                                                    value={
                                                        medicalForm.find((item) => item.QuestionID === 40)?.Answer || ""
                                                    }
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Your answer"
                                                    required
                                                />
                                                    <div className="invalid-feedback">This is a required question</div>
                                            </div>
                                            <div className="position-relative my-4">
                                                <hr className='my-0'/>
                                                <span className="position-absolute top-50 start-50 translate-middle bg-white px-2 text-muted fs-18">Screenshots</span>
                                            </div>

                                            <div className='col-md-12 mt-4 mb-4'>
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <input 
                                                        className="form-control d-none" 
                                                        type="file" 
                                                        id="fileStamp"
                                                        accept=".png, .jpeg, .jpg"
                                                        onChange={handleFileChange}
                                                    />
                                                    <label htmlFor="fileStamp" className="form-control d-flex justify-content-between align-items-center file-uploader">
                                                        <span>Upload Image</span>
                                                        <span className="upload-icon" style={{ marginLeft: 'auto' }}>
                                                            <i className="bi bi-upload"></i>
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>

                                            {screenShots.filter(f => f.Action != 'D').length > 0 && screenShots.filter(f => f.Action != 'D').map((m, i) => {

                                                const mimeType = m.Action == 'A' ? "image/jpeg" : helper.getMimeType(m.Name);
                                                const blob = m.Action == 'A' ? m.Blob : new Blob([new Uint8Array(m.Buffer.data)], { type: mimeType });
                                                const objectURL = URL.createObjectURL(blob); 

                                                return (
                                                    <div key={i} className='col-md-6 mt-3'>
                                                        <div className="alert alert-dismissible alert-light padding-0 btnCapture">
                                                            <button onClick={() => removeScreenshot(i)} type="button" className="btn-close padding-5 margin-5"></button>
                                                            <img src={objectURL} alt="Screenshot" style={{ width: '100%' }} />
                                                        </div>
                                                    </div>
                                                    
                                                );
                                            })}

                                        </>
                                    )}

                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#viewModal">Close</button>
                            <button type="submit" form='juvenileMedicalForm' className="btn btn-success">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
 


        </>
    )

}

export default Dashboard;